module.exports = __webpack_public_path__ + "img/SDG-03-EN-INVERTED.95d7991f.png";